import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { WtfAnimations } from "../../../../utils/others/core/animations";
@Component({
    selector: "app-sign-in",
    templateUrl: "./sign-in.component.html",
    styleUrls: ["./sign-in.component.scss"],
    animations: WtfAnimations,
    encapsulation: ViewEncapsulation.None,
})
export class SignInComponent implements OnInit {
    constructor() {}

    ngOnInit(): void {}
}
